module.exports = __webpack_public_path__ + "static/img/welcome_join_us.6dd986af.png";